import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Mail, Phone } from "lucide-react";
import { NAV_ITEMS, LOGO } from "../../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-20 pb-8">
        <p className="font-heading uppercase font-semibold text-outline-white leading-none text-[18vw] xl:text-[11rem] whitespace-nowrap select-none">
          Le Boulou
        </p>

        <div className="grid md:grid-cols-3 gap-12 mt-16 border-t border-white/10 pt-14">
          <div>
            <p className="font-heading uppercase tracking-wider text-sm text-rouge mb-5">Le Club</p>
            <img src={LOGO} alt="Club Cycliste Le Boulou — logo officiel" className="h-16 w-auto bg-white px-2 py-1 mb-6" />
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-rouge shrink-0" />
                <span data-testid="footer-address">1 avenue du Stade, Complexe des Échards<br />66160 Le Boulou</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-rouge shrink-0" />
                <a href="mailto:ccleboulou@live.fr" data-testid="footer-email" className="hover:text-rouge transition-colors">ccleboulou@live.fr</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-rouge shrink-0" />
                <a href="tel:+33782854699" data-testid="footer-phone" className="hover:text-rouge transition-colors">07 82 85 46 99</a>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-heading uppercase tracking-wider text-sm text-rouge mb-5">Liens rapides</p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm text-white/70">
              {NAV_ITEMS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="hover:text-rouge transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-heading uppercase tracking-wider text-sm text-rouge mb-5">Suivez-nous</p>
            <div className="flex gap-3">
              <a
                href="#"
                data-testid="footer-social-facebook"
                aria-label="Facebook du club (lien à venir)"
                className="flex h-11 w-11 items-center justify-center border border-white/20 hover:bg-rouge hover:border-rouge transition-[background-color,border-color] duration-300"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                data-testid="footer-social-instagram"
                aria-label="Instagram du club (lien à venir)"
                className="flex h-11 w-11 items-center justify-center border border-white/20 hover:bg-rouge hover:border-rouge transition-[background-color,border-color] duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
            <p className="mt-5 text-xs text-white/40">Liens des réseaux sociaux à ajouter.</p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Club Cycliste Le Boulou. Tous droits réservés.</p>
          <div className="flex gap-6">
            <Link to="/mentions-legales" data-testid="footer-mentions-legales" className="hover:text-white transition-colors">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" data-testid="footer-confidentialite" className="hover:text-white transition-colors">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
